module.exports = __webpack_public_path__ + "img/portrait01.0d2874c2.png";